import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import {
  hasOngoingTask,
  isAlternativeForProduct,
  isMainProduct,
} from "@coworker/app/src/components/RoomSettings/Molecules/MediaArticles.helper";
import { getMainAndAlternativeProducts } from "@coworker/app/src/components/RoomSettings/tools";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { TaskLinks } from "@coworker/app/src/components/RoomSettings/types/taskLink";
import { SalesStopData } from "@coworker/app/src/components/RoomSettings/types/article";

export const getMediaItemBadges = (
  articleId: string,
  allArticleIds: string[],
  t: (key: string) => string,
  taskLinks: TaskLinks,
  salesStopData?: SalesStopData | null,
  media?: Media,
  shouldShowProductBadges = true
) => {
  const showTaskBadge = hasOngoingTask(allArticleIds, taskLinks);
  const itemBadges: ItemBadge[] = [];

  if (shouldShowProductBadges && media) {
    const mainAndAlternativeProduct = getMainAndAlternativeProducts(media);

    const isMainItem = isMainProduct(
      articleId,
      mainAndAlternativeProduct.mainProductId1,
      mainAndAlternativeProduct.mainProductId2
    );

    const isAlternativeItem = isAlternativeForProduct(
      articleId,
      mainAndAlternativeProduct.alternativeProductId1 ?? "",
      mainAndAlternativeProduct.alternativeProductId2 ?? ""
    );

    const numberMain = articleId === media.mainProductId1 ? 1 : 2;

    if (isMainItem) {
      itemBadges.push({
        text:
          numberMain === 1
            ? t("mainProductOneString")
            : t("mainProductTwoString"),
        colour: "blue",
      });
    }

    if (isAlternativeItem) {
      itemBadges.push({
        text: t("backupProductString").toUpperCase(),
        colour: "grey",
      });
    }
  }

  if (showTaskBadge) {
    itemBadges.push({
      text: (t("ongoingTasksString") as string).toUpperCase(),
      colour: "green",
    });
  }

  if (salesStopData) {
    itemBadges.push({
      text: t("salesStopString").toUpperCase(),
      colour: "red",
    });
  }

  return itemBadges;
};
